import React from "react";
import Accordion from "react-bootstrap/Accordion";
import "../../assets/css/terminos-mundial.css";

const TerminosMundialComponent: React.FC = () => {
  return (
    <section className="terminos-mundial-section">
      <div className="terminos-mundial-bg"></div>
      
      <div className="terminos-mundial-container">
        
        <h2 className="terminos-mundial-title">Términos y condiciones</h2>
        <p className="terminos-mundial-subtitle">
          Consulta toda la información sobre la campaña "Estás a un Hyundai de la Copa Mundial de la FIFA 2026™"
        </p>
        
        <div className="terminos-mundial-card">
          <p className="terminos-mundial-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
          
          <hr className="terminos-mundial-divider" />
          
          <div className="terminos-mundial-list">
            <Accordion>
              <Accordion.Item eventKey="0" className="mb-3" style={{ border: '1px solid #ddd', borderRadius: '12px', overflow: 'hidden' }}>
                <Accordion.Header>1. Ejemplo de término o condición</Accordion.Header>
                <Accordion.Body>
                  Detalle del primer punto de términos y condiciones para el mundial.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1" className="mb-3" style={{ border: '1px solid #ddd', borderRadius: '12px', overflow: 'hidden' }}>
                <Accordion.Header>2. Ejemplo de término o condición</Accordion.Header>
                <Accordion.Body>
                  Detalle del segundo punto de términos y condiciones.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2" style={{ border: '1px solid #ddd', borderRadius: '12px', overflow: 'hidden' }}>
                <Accordion.Header>3. Ejemplo de término o condición</Accordion.Header>
                <Accordion.Body>
                  Detalle del tercer punto de términos y condiciones.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TerminosMundialComponent;
